"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5152],{

/***/ 52809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ BakeShadows; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_three_fiber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29544);



function BakeShadows() {
  const gl = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(state => state.gl);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    gl.shadowMap.autoUpdate = false;
    gl.shadowMap.needsUpdate = true;
    return () => {
      gl.shadowMap.autoUpdate = gl.shadowMap.needsUpdate = true;
    };
  }, [gl.shadowMap]);
  return null;
}




/***/ }),

/***/ 10533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ usePerformanceMonitor; },
/* harmony export */   "A": function() { return /* binding */ PerformanceMonitor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_three_fiber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29544);




const context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function PerformanceMonitor({
  iterations = 10,
  ms = 250,
  threshold = 0.75,
  step = 0.1,
  factor: _factor = 0.5,
  flipflops = Infinity,
  bounds = refreshrate => refreshrate > 100 ? [60, 100] : [40, 60],
  onIncline,
  onDecline,
  onChange,
  onFallback,
  children
}) {
  const decimalPlacesRatio = Math.pow(10, 0);
  const [api, _] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => ({
    fps: 0,
    index: 0,
    factor: _factor,
    flipped: 0,
    refreshrate: 0,
    fallback: false,
    frames: [],
    averages: [],
    subscriptions: new Map(),
    subscribe: ref => {
      const key = Symbol();
      api.subscriptions.set(key, ref.current);
      return () => void api.subscriptions.delete(key);
    }
  }));
  let lastFactor = 0;
  (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.A)(() => {
    const {
      frames,
      averages
    } = api; // If the fallback has been reached do not continue running samples

    if (api.fallback) return;

    if (averages.length < iterations) {
      frames.push(performance.now());
      const msPassed = frames[frames.length - 1] - frames[0];

      if (msPassed >= ms) {
        api.fps = Math.round(frames.length / msPassed * 1000 * decimalPlacesRatio) / decimalPlacesRatio;
        api.refreshrate = Math.max(api.refreshrate, api.fps);
        averages[api.index++ % iterations] = api.fps;

        if (averages.length === iterations) {
          const [lower, upper] = bounds(api.refreshrate);
          const upperBounds = averages.filter(value => value >= upper);
          const lowerBounds = averages.filter(value => value < lower); // Trigger incline when more than -threshold- avgs exceed the upper bound

          if (upperBounds.length > iterations * threshold) {
            api.factor = Math.min(1, api.factor + step);
            api.flipped++;
            if (onIncline) onIncline(api);
            api.subscriptions.forEach(value => value.onIncline && value.onIncline(api));
          } // Trigger decline when more than -threshold- avgs are below the lower bound


          if (lowerBounds.length > iterations * threshold) {
            api.factor = Math.max(0, api.factor - step);
            api.flipped++;
            if (onDecline) onDecline(api);
            api.subscriptions.forEach(value => value.onDecline && value.onDecline(api));
          }

          if (lastFactor !== api.factor) {
            lastFactor = api.factor;
            if (onChange) onChange(api);
            api.subscriptions.forEach(value => value.onChange && value.onChange(api));
          }

          if (api.flipped > flipflops && !api.fallback) {
            api.fallback = true;
            if (onFallback) onFallback(api);
            api.subscriptions.forEach(value => value.onFallback && value.onFallback(api));
          }

          api.averages = []; // Resetting the refreshrate creates more problems than it solves atm
          // api.refreshrate = 0
        }

        api.frames = [];
      }
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(context.Provider, {
    value: api
  }, children);
}
function usePerformanceMonitor({
  onIncline,
  onDecline,
  onChange,
  onFallback
}) {
  const api = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    onIncline,
    onDecline,
    onChange,
    onFallback
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    ref.current.onIncline = onIncline;
    ref.current.onDecline = onDecline;
    ref.current.onChange = onChange;
    ref.current.onFallback = onFallback;
  }, [onIncline, onDecline, onChange, onFallback]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => api.subscribe(ref), [api]);
}




/***/ }),

/***/ 70587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Preload; }
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99477);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_three_fiber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29544);




function Preload({
  all,
  scene,
  camera
}) {
  const gl = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(({
    gl
  }) => gl);
  const dCamera = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(({
    camera
  }) => camera);
  const dScene = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(({
    scene
  }) => scene); // Layout effect because it must run before React commits

  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => {
    const invisible = [];

    if (all) {
      (scene || dScene).traverse(object => {
        if (object.visible === false) {
          invisible.push(object);
          object.visible = true;
        }
      });
    } // Now compile the scene


    gl.compile(scene || dScene, camera || dCamera); // And for good measure, hit it with a cube camera

    const cubeRenderTarget = new three__WEBPACK_IMPORTED_MODULE_2__.WebGLCubeRenderTarget(128);
    const cubeCamera = new three__WEBPACK_IMPORTED_MODULE_2__.CubeCamera(0.01, 100000, cubeRenderTarget);
    cubeCamera.update(gl, scene || dScene);
    cubeRenderTarget.dispose(); // Flips these objects back

    invisible.forEach(object => object.visible = false);
  }, []);
  return null;
}




/***/ }),

/***/ 90319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useFBO; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99477);
/* harmony import */ var _react_three_fiber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29544);




// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function useFBO(
/** Width in pixels, or settings (will render fullscreen by default) */
width,
/** Height in pixels */
height,
/**Settings */
settings) {
  const size = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(state => state.size);
  const viewport = (0,_react_three_fiber__WEBPACK_IMPORTED_MODULE_1__.z)(state => state.viewport);

  const _width = typeof width === 'number' ? width : size.width * viewport.dpr;

  const _height = typeof height === 'number' ? height : size.height * viewport.dpr;

  const _settings = (typeof width === 'number' ? settings : width) || {};

  const {
    samples = 0,
    depth,
    ...targetSettings
  } = _settings;
  const target = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const target = new three__WEBPACK_IMPORTED_MODULE_2__.WebGLRenderTarget(_width, _height, {
      minFilter: three__WEBPACK_IMPORTED_MODULE_2__.LinearFilter,
      magFilter: three__WEBPACK_IMPORTED_MODULE_2__.LinearFilter,
      type: three__WEBPACK_IMPORTED_MODULE_2__.HalfFloatType,
      ...targetSettings
    });

    if (depth) {
      target.depthTexture = new three__WEBPACK_IMPORTED_MODULE_2__.DepthTexture(_width, _height, three__WEBPACK_IMPORTED_MODULE_2__.FloatType);
    }

    target.samples = samples;
    return target;
  }, []);
  react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect(() => {
    target.setSize(_width, _height);
    if (samples) target.samples = samples;
  }, [samples, target, _width, _height]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    return () => target.dispose();
  }, []);
  return target;
}




/***/ }),

/***/ 25152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Team_Team; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 3 modules
var react_three_fiber_esm = __webpack_require__(49606);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/PerformanceMonitor.js
var PerformanceMonitor = __webpack_require__(10533);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/BakeShadows.js
var BakeShadows = __webpack_require__(52809);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/Preload.js
var Preload = __webpack_require__(70587);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useGLTF.js + 4 modules
var useGLTF = __webpack_require__(74664);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useProgress.js
var useProgress = __webpack_require__(29521);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useFBO.js
var useFBO = __webpack_require__(90319);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/index-673ef987.esm.js + 1 modules
var index_673ef987_esm = __webpack_require__(29544);
// EXTERNAL MODULE: ./context/Team.tsx
var Team = __webpack_require__(24397);
// EXTERNAL MODULE: ./node_modules/@react-spring/three/dist/react-spring_three.modern.mjs
var react_spring_three_modern = __webpack_require__(1900);
;// CONCATENATED MODULE: ./3D/models/Louie/Louie.tsx







const Louie = (param)=>{
    let { inConfig , outConfig , active  } = param;
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/louie.glb");
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Mesh_0001.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Louie_Louie = (Louie);

;// CONCATENATED MODULE: ./3D/models/Louie/index.ts


;// CONCATENATED MODULE: ./3D/models/Ryan/Ryan.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Ryan = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/ryan.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Ryan.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Ryan_Ryan = (Ryan);

;// CONCATENATED MODULE: ./3D/models/Ryan/index.ts


;// CONCATENATED MODULE: ./3D/models/Alex/Alex.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Alex = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/alex.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Alex.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Alex_Alex = (Alex);

;// CONCATENATED MODULE: ./3D/models/Alex/index.ts


;// CONCATENATED MODULE: ./3D/models/Anya/Anya.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Anya = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/anya.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0.45 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0.45 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes["scandy-pro-2022-12-09-t21-50-48-633-z"].geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Anya_Anya = (Anya);

;// CONCATENATED MODULE: ./3D/models/Anya/index.ts


;// CONCATENATED MODULE: ./3D/models/Brett/Brett.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Brett = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/brett.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Brett.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Brett_Brett = (Brett);

;// CONCATENATED MODULE: ./3D/models/Brett/index.ts


;// CONCATENATED MODULE: ./3D/models/Corinne/Corinne.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Corinne = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/corinne.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Corinne.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Corinne_Corinne = (Corinne);

;// CONCATENATED MODULE: ./3D/models/Corinne/index.ts


;// CONCATENATED MODULE: ./3D/models/Emma/Emma.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Emma = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/emma.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Emma.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Emma_Emma = (Emma);

;// CONCATENATED MODULE: ./3D/models/Emma/index.ts


;// CONCATENATED MODULE: ./3D/models/Matt/Matt.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Matt = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/matt.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.matt_head_3d1.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Matt_Matt = (Matt);

;// CONCATENATED MODULE: ./3D/models/Matt/index.ts


;// CONCATENATED MODULE: ./3D/models/Gretch/Gretch.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Gretch = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/gretch.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Gretch.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Gretch_Gretch = (Gretch);

;// CONCATENATED MODULE: ./3D/models/Gretch/index.ts


;// CONCATENATED MODULE: ./3D/models/Marty/Marty.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Marty = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/marty.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Marty.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Marty_Marty = (Marty);

;// CONCATENATED MODULE: ./3D/models/Marty/index.ts


;// CONCATENATED MODULE: ./3D/models/Sylvie/Sylvie.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Sylvie = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/sylvie.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Sylvie.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Sylvie_Sylvie = (Sylvie);

;// CONCATENATED MODULE: ./3D/models/Sylvie/index.ts


;// CONCATENATED MODULE: ./3D/models/Haseeb/Haseeb.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Haseeb = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/haseeb.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Haseeb.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Haseeb_Haseeb = (Haseeb);

;// CONCATENATED MODULE: ./3D/models/Haseeb/index.ts


;// CONCATENATED MODULE: ./3D/models/Soyeon/Soyeon.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Soyeon = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/soyeon.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Soyeon.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Soyeon_Soyeon = (Soyeon);

;// CONCATENATED MODULE: ./3D/models/Soyeon/index.ts


;// CONCATENATED MODULE: ./3D/models/Keely/Keely.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Keely = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/keely.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Keely.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Keely_Keely = (Keely);

;// CONCATENATED MODULE: ./3D/models/Keely/index.ts


;// CONCATENATED MODULE: ./3D/models/Marco/Marco.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Marco = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/marco.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes["scandy-pro-2022-07-27-t16-17-46-833-z-m_(1)002"].geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Marco_Marco = (Marco);

;// CONCATENATED MODULE: ./3D/models/Marco/index.ts


;// CONCATENATED MODULE: ./3D/models/Lynn/Lynn.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Lynn = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/lynn.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes["lynn_meshtrimmed_(1)"].geometry,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Lynn_Lynn = (Lynn);

;// CONCATENATED MODULE: ./3D/models/Lynn/index.ts


;// CONCATENATED MODULE: ./3D/models/Alise/Alise.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Alise = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/alise.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Alise_1.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Alise_Alise = (Alise);

;// CONCATENATED MODULE: ./3D/models/Alise/index.ts


;// CONCATENATED MODULE: ./3D/models/Generic/Generic.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Generic = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/generic.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Cube_Cube001.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Generic_Generic = (Generic);

;// CONCATENATED MODULE: ./3D/models/Generic/index.ts


;// CONCATENATED MODULE: ./3D/models/Siobahn/Siobahn.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Siobahn = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/siobahn.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Siobahn.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Siobahn_Siobahn = (Siobahn);

;// CONCATENATED MODULE: ./3D/models/Siobahn/index.ts


;// CONCATENATED MODULE: ./3D/models/Bjoern/Bjoern.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Bjoern = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/bjoern.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Bjoern.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Bjoern_Bjoern = (Bjoern);

;// CONCATENATED MODULE: ./3D/models/Bjoern/index.ts


;// CONCATENATED MODULE: ./3D/models/Dani/Dani.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Dani = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/dani.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes["192k_uv"].geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Dani_Dani = (Dani);

;// CONCATENATED MODULE: ./3D/models/Dani/index.ts


;// CONCATENATED MODULE: ./3D/models/Dave/Dave.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Dave = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/dave.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Eric.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Dave_Dave = (Dave);

;// CONCATENATED MODULE: ./3D/models/Dave/index.ts


;// CONCATENATED MODULE: ./3D/models/Eric/Eric.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Eric = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/eric.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Eric001.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Eric_Eric = (Eric);

;// CONCATENATED MODULE: ./3D/models/Eric/index.ts


;// CONCATENATED MODULE: ./3D/models/Logo/Logo.tsx
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/ 






const Logo = (param)=>{
    let { active , outConfig , inConfig  } = param;
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/logo.glb");
    const mesh = (0,react.useRef)(new three_module.Mesh());
    const { outPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        outPosition: active ? 0 : 5,
        outConfig
    });
    const { inPosition  } = (0,react_spring_three_modern/* useSpring */.q_)({
        inPosition: active ? 0 : -5,
        inConfig
    });
    (0,index_673ef987_esm.A)((state)=>{
        if ((mesh === null || mesh === void 0 ? void 0 : mesh.current) && active) {
            mesh.current.rotation.y += 0.01;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern.a.mesh, {
        ref: mesh,
        geometry: nodes.Logo.geometry,
        receiveShadow: true,
        "position-x": 0,
        "position-y": active ? inPosition : outPosition,
        "position-z": 0,
        "rotation-z": Math.PI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
            color: 0xffffff,
            roughness: 0,
            metalness: 1
        })
    });
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ./3D/models/Logo/index.ts


;// CONCATENATED MODULE: ./3D/scenes/FBOScene/FBOScene.tsx



























const inConfig = {
    mass: 1,
    tension: 100,
    friction: 20,
    precision: 0.001
};
const outConfig = {
    mass: 10,
    tension: 500,
    friction: 100,
    precision: 0.001,
    velocity: 0.01
};
const FBOScene = ()=>{
    const pointLight = (0,react.useRef)(null);
    const optedOut = [
        "Camille Marzella"
    ];
    const { config: { currentTeamMember  }  } = (0,Team/* useTeamMemberContext */.rK)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pointLight", {
                ref: pointLight,
                intensity: 300000000,
                position: [
                    0,
                    30,
                    30
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pointLight", {
                ref: pointLight,
                intensity: 300000,
                position: [
                    -10,
                    0,
                    -30
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_Logo, {
                        active: !currentTeamMember,
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Louie_Louie, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Louie Williford",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Ryan_Ryan, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Ryan Simpson",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alex_Alex, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Alex Christie",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anya_Anya, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Anya Sherriuble",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Brett_Brett, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Brett Cimbalik",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Corinne_Corinne, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Corinne Resch",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Emma_Emma, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Emma Sims",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Matt_Matt, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Matt Harlan",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gretch_Gretch, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Gretchen Robertson",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Marty_Marty, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Marty Warfel",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sylvie_Sylvie, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Sylvia Maria Rosa",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Haseeb_Haseeb, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Haseeb Khan",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Soyeon_Soyeon, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Soyeon Kim",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Keely_Keely, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Keely Dowd",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Marco_Marco, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Marco Torres",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lynn_Lynn, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Lynn Hurley",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alise_Alise, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Alise Jarmusz",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Generic_Generic, {
                        active: optedOut.includes(currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name),
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Siobahn_Siobahn, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Siobahn Schuck",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bjoern_Bjoern, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Bjoern Sagstad",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dani_Dani, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Dani Rev",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dave_Dave, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Dave Lashinsky",
                        inConfig: inConfig,
                        outConfig: outConfig
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Eric_Eric, {
                        active: (currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.name) === "Eric Dennis",
                        inConfig: inConfig,
                        outConfig: outConfig
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FBOScene_FBOScene = (FBOScene);

// EXTERNAL MODULE: ./node_modules/postprocessing/build/index.js
var build = __webpack_require__(62371);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./3D/effects/Transition/Transition.ts






var GLITCH_PARAMS;
(function(GLITCH_PARAMS) {
    GLITCH_PARAMS[GLITCH_PARAMS["MIN_DELAY"] = 0.0] = "MIN_DELAY";
    GLITCH_PARAMS[GLITCH_PARAMS["MAX_DELAY"] = 2.343] = "MAX_DELAY";
    GLITCH_PARAMS[GLITCH_PARAMS["MIN_DURATION"] = 0.2] = "MIN_DURATION";
    GLITCH_PARAMS[GLITCH_PARAMS["MAX_DURATION"] = 1.313] = "MAX_DURATION";
    GLITCH_PARAMS[GLITCH_PARAMS["GLITCH_RATIO"] = 0.085] = "GLITCH_RATIO";
    GLITCH_PARAMS[GLITCH_PARAMS["COLUMNS"] = 0] = "COLUMNS";
})(GLITCH_PARAMS || (GLITCH_PARAMS = {}));
function useTransition(param) {
    let { cam , scene , renderTarget  } = param;
    const { gl  } = (0,index_673ef987_esm.z)();
    const { config: { currentTeamMember  }  } = (0,Team/* useTeamMemberContext */.rK)();
    const { config: { fetchGlitchVal  }  } = (0,Team/* useGlitchContext */.oB)();
    const { width  } = (0,useWindowSize/* default */.Z)();
    const [glitchVal, setGlitchVal] = (0,react.useState)(0.0);
    const [pixelationVal, setPixelationVal] = (0,react.useState)(0);
    (0,index_673ef987_esm.A)(()=>{
        if (fetchGlitchVal && currentTeamMember) {
            const newGlitchVal = fetchGlitchVal();
            if (glitchVal !== newGlitchVal) {
                setGlitchVal(newGlitchVal);
            }
        }
    });
    (0,react.useEffect)(()=>{
        if (width) {
            // 992 is the 'lg' breakpoint width value
            if (width > 992) setPixelationVal(8);
            else setPixelationVal(5);
        }
    }, [
        width
    ]);
    return (0,react.useMemo)(()=>{
        const renderScene = new build/* RenderPass */.CD(scene, cam);
        const comp = new build/* EffectComposer */.xC(gl, renderTarget);
        comp.autoRenderToScreen = false;
        comp.addPass(renderScene);
        const chromaticAbberationPass = new build/* EffectPass */.H5(cam, new build/* ChromaticAberrationEffect */.YY({
            radialModulation: true,
            modulationOffset: 0.2,
            offset: new three_module.Vector2(0.018, 0.01)
        }));
        chromaticAbberationPass.enabled = currentTeamMember ? true : false;
        comp.addPass(chromaticAbberationPass);
        const pixelationPass = new build/* EffectPass */.H5(cam, new build/* PixelationEffect */.Qg(pixelationVal));
        comp.addPass(pixelationPass);
        const glitchEffect = new build/* GlitchEffect */.sy({
            delay: new three_module.Vector2(GLITCH_PARAMS.MIN_DELAY, GLITCH_PARAMS.MAX_DELAY),
            duration: new three_module.Vector2(GLITCH_PARAMS.MIN_DURATION, GLITCH_PARAMS.MAX_DURATION),
            strength: new three_module.Vector2(glitchVal * 0.25, glitchVal),
            ratio: GLITCH_PARAMS.GLITCH_RATIO,
            columns: GLITCH_PARAMS.COLUMNS
        });
        glitchEffect.mode = build/* GlitchMode.CONSTANT_MILD */.O7.CONSTANT_MILD;
        const glitchPass = new build/* EffectPass */.H5(cam, glitchEffect);
        comp.addPass(glitchPass);
        return [
            comp
        ];
    }, [
        scene,
        cam,
        gl,
        renderTarget,
        currentTeamMember,
        glitchVal,
        // glitchValToo,
        // glitchValChanged,
        pixelationVal
    ]);
}
const Transition = {};
/* harmony default export */ var Transition_Transition = ((/* unused pure expression or super */ null && (Transition)));

;// CONCATENATED MODULE: ./3D/models/TeamTV/TeamTV.tsx








const TeamTV = (props)=>{
    const group = (0,react.useRef)(null);
    const { nodes  } = (0,useGLTF/* useGLTF */.L)("/objects/TV.glb");
    const screen = (0,react.useRef)(new three_module.Mesh());
    const { size , gl , camera , scene  } = (0,index_673ef987_esm.z)();
    const [position, setPosition] = (0,react.useState)(new three_module.Vector3());
    const [rotation, setRotation] = (0,react.useState)(new three_module.Euler());
    const { setContext  } = (0,Team/* useTeamMemberContext */.rK)();
    // this is the camera and the scene in the fbo scene
    const fboCam = react.useRef(null);
    const fboScene = react.useMemo(()=>{
        const scene = new three_module.Scene();
        return scene;
    }, []);
    const { progress  } = (0,useProgress/* useProgress */.S)();
    let // 4:3 aspect ratio
    ScreenRes;
    (function(ScreenRes) {
        ScreenRes[ScreenRes["Width"] = 360] = "Width";
        ScreenRes[ScreenRes["Height"] = 240] = "Height";
    })(ScreenRes || (ScreenRes = {}));
    const fboRenderTarget = (0,useFBO/* useFBO */.R)(ScreenRes.Width, ScreenRes.Height, {
        minFilter: three_module.NearestFilter,
        magFilter: three_module.NearestFilter,
        format: three_module.RGBAFormat,
        stencilBuffer: false,
        depthBuffer: true,
        type: three_module.FloatType,
        samples: 4
    });
    // these are the effects for the tv screen
    const { config: { outerGL , outerScene , outerCam  }  } = (0,Team/* useTeamMemberContext */.rK)();
    // just removing transition effects for now :o
    const [base] = useTransition({
        cam: fboCam.current || new three_module.PerspectiveCamera(),
        scene: fboScene || new three_module.Scene(),
        renderTarget: fboRenderTarget || new three_module.WebGLRenderTarget(size.width, size.height)
    });
    // link tv scene to render target
    (0,index_673ef987_esm.A)((state)=>{
        const { gl  } = state;
        if (fboCam === null || fboCam === void 0 ? void 0 : fboCam.current) {
            gl.setRenderTarget(fboRenderTarget);
            gl.render(fboScene, fboCam.current);
            gl.setRenderTarget(null);
        }
    });
    (0,index_673ef987_esm.A)(()=>{
        base.render();
        if (!base.autoRenderToScreen) {
            // need to re-render outer scene since new texture has been added each frame
            if (outerGL && outerScene && outerCam) {
                outerGL.setRenderTarget(null);
                outerGL.render(outerScene, outerCam);
            }
        }
    }, -1);
    // watch window resize and set camera/tv position accordingly
    (0,react.useEffect)(()=>{
        if (fboCam.current) {
            fboCam.current.zoom = 4;
            fboCam.current.lookAt(0, 0, 0);
            fboCam.current.updateProjectionMatrix();
            // mobile & tablet
            if (size.width <= 992) {
                setPosition(new three_module.Vector3(0, 0, -1.25));
                setRotation(new three_module.Euler(Math.PI / 2, 0, 0));
                return;
            }
            setPosition(new three_module.Vector3(2, 0.2, -1.75));
            setRotation(new three_module.Euler(Math.PI / 2, 0, 0.1));
        }
    }, [
        size
    ]);
    (0,react.useEffect)(()=>{
        setContext({
            outerGL: gl,
            outerScene: scene,
            outerCam: camera
        });
    }, [
        gl,
        scene,
        camera
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("group", {
        ref: group,
        ...props,
        dispose: null,
        position: position,
        rotation: rotation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("perspectiveCamera", {
                ref: fboCam,
                position: [
                    20,
                    0.05,
                    0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {
                receiveShadow: true,
                name: "Cube004",
                geometry: nodes.Cube004.geometry,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {})
            }),
            (0,index_673ef987_esm.g)(/*#__PURE__*/ (0,jsx_runtime.jsx)(FBOScene_FBOScene, {}), fboScene),
            progress >= 100 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {
                        name: "Cube004_1",
                        geometry: nodes.Cube004_1.geometry,
                        ref: screen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
                            map: base.outputBuffer.texture ? base.outputBuffer.texture : fboRenderTarget.texture
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {
                        castShadow: true,
                        receiveShadow: true,
                        name: "Cube004_2",
                        geometry: nodes.Cube004_1.geometry,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshPhysicalMaterial", {
                            clearcoat: 1,
                            clearcoatRoughness: 0.09,
                            toneMapped: true,
                            transmission: 1,
                            thickness: 5,
                            roughness: 0.15,
                            emissive: "#fff",
                            emissiveMap: base.outputBuffer.texture ? base.outputBuffer.texture : fboRenderTarget.texture,
                            emissiveIntensity: 0.39
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var TeamTV_TeamTV = (TeamTV);

;// CONCATENATED MODULE: ./3D/models/TeamTV/index.ts


;// CONCATENATED MODULE: ./3D/scenes/Team/objects/LightingRig/LightingRig.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const AnimatedPointLight = (0,styled_components_browser_esm/* default */.ZP)(react_spring_three_modern/* animated.pointLight */.q.pointLight).withConfig({
    componentId: "sc-280d0767-0"
})(_templateObject());
const AnimatedAmbientLight = (0,styled_components_browser_esm/* default */.ZP)(react_spring_three_modern/* animated.ambientLight */.q.ambientLight).withConfig({
    componentId: "sc-280d0767-1"
})(_templateObject1());
const FillLight = (param)=>{
    let { brightness , color  } = param;
    const { gl  } = (0,index_673ef987_esm.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPointLight, {
        intensity: brightness,
        color: color,
        position: [
            2,
            7,
            3
        ],
        castShadow: true,
        "shadow-mapSize-height": gl.capabilities.maxTextureSize,
        "shadow-mapSize-width": gl.capabilities.maxTextureSize,
        "shadow-radius": 10,
        "shadow-bias": -0.00001
    });
};
const LightingRig = ()=>{
    const [animationTrigger, setAnimationTrigger] = (0,react.useState)(false);
    const { progress  } = (0,useProgress/* useProgress */.S)();
    const lightingSpringConfig = {
        friction: 100,
        tension: 50
    };
    // handle light fading in on load
    const { animateFillBrightness  } = (0,react_spring_three_modern/* useSpring */.q_)({
        animateFillBrightness: animationTrigger ? 3 * Math.PI : 0,
        config: lightingSpringConfig
    });
    const { animateAmbientBrightness  } = (0,react_spring_three_modern/* useSpring */.q_)({
        animateAmbientBrightness: animationTrigger ? 0.02 * Math.PI : 0,
        config: lightingSpringConfig
    });
    (0,react.useEffect)(()=>{
        if (progress === 100) {
            setAnimationTrigger(true);
        }
    }, [
        setAnimationTrigger,
        progress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FillLight, {
                brightness: animateFillBrightness,
                color: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedAmbientLight, {
                intensity: animateAmbientBrightness
            })
        ]
    });
};
/* harmony default export */ var LightingRig_LightingRig = (LightingRig);

;// CONCATENATED MODULE: ./3D/scenes/Team/objects/LightingRig/index.ts


;// CONCATENATED MODULE: ./3D/scenes/Team/Team.tsx

function Team_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100vh !important;\n  "
    ]);
    Team_templateObject = function() {
        return data;
    };
    return data;
}
function Team_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute !important;\n  pointer-events: none !important;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  ",
        "\n"
    ]);
    Team_templateObject1 = function() {
        return data;
    };
    return data;
}






// custom 3D objects



const StyledCanvas = (0,styled_components_browser_esm/* default */.ZP)(react_three_fiber_esm/* Canvas */.Xz).withConfig({
    componentId: "sc-6869215-0"
})(Team_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(Team_templateObject());
});
const TeamScene = (param)=>{
    let { teamMembers  } = param;
    const { config , setContext  } = (0,Team/* useTeamMemberContext */.rK)();
    const [dpr, setDpr] = (0,react.useState)(2);
    const [onClient, setOnClient] = (0,react.useState)(false);
    const { pathname  } = (0,router.useRouter)();
    const handleWindowResize = (0,react.useCallback)(()=>{
        setContext({
            innerHeight: window.innerHeight
        });
    }, [
        setContext
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", handleWindowResize, false);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, [
        handleWindowResize
    ]);
    (0,react.useEffect)(()=>{
        // format and push teamMembers into context
        const formattedTeamMembers = [];
        // this removes the annoying typename prop
        for (const teamMember of teamMembers){
            const { teamMemberPosition , teamMemberName  } = teamMember || {};
            formattedTeamMembers.push({
                name: teamMemberName,
                position: teamMemberPosition
            });
        }
        formattedTeamMembers.sort((a, b)=>a.name.localeCompare(b.name));
        setContext({
            teamMembers: formattedTeamMembers,
            innerHeight: window.innerHeight
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (pathname) setOnClient(true);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Team/* TeamMemberContext.Consumer */.SH.Consumer, {
        children: (value)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Team/* GlitchContext.Consumer */.y3.Consumer, {
                children: (glitchVal)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCanvas, {
                        dpr: dpr,
                        $innerHeight: config.innerHeight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Team/* TeamMemberContext.Provider */.SH.Provider, {
                            value: value,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Team/* GlitchContext.Provider */.y3.Provider, {
                                value: glitchVal,
                                children: onClient && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerformanceMonitor/* PerformanceMonitor */.A, {
                                    onDecline: ()=>setDpr(1),
                                    onIncline: ()=>setDpr(1.5),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightingRig_LightingRig, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamTV_TeamTV, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BakeShadows/* BakeShadows */.P, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Preload/* Preload */.q, {
                                            all: true
                                        })
                                    ]
                                })
                            })
                        })
                    })
            })
    });
};
/* harmony default export */ var Team_Team = (TeamScene);

;// CONCATENATED MODULE: ./3D/scenes/Team/index.ts



/***/ })

}]);